<template>
    <div>
        <div style="display: flex; justify-content: space-between;">
            <div class="homedashboard" style="width: 350px">

                <router-link :to="{ path: '/homedashboard/' + this.$org_encryprt.label }">
                    <q-item clickable @click="checkPath">
                        <div style="display: flex;">
                            <q-item-section avatar> <q-icon name="house" /></q-item-section>
                            <q-item-section>
                                Click Here to go to HomeDashboard

                            </q-item-section>
                        </div>
                    </q-item>
                </router-link>

            </div>
            <div class="btn-add">
                <button class="add" @click="addconnection">Add Connection <q-icon name="add"
                        class="q-icon"></q-icon></button>
                <button class="refresh" @click="refresh" :disabled="isFetching">{{ buttonText }}</button>
            </div>
        </div>
        <div class="table-wrapper q-mb-sm">

            <table>
                <thead>
                    <tr>
                        <!-- <th style="width: 3%">S.NO</th> -->
                        <th>Seller Name</th>
                        <th>Region</th>
                        <th>Seller ID</th>
                        <!-- <th>Marketplace</th> -->
                        <th>Type</th>
                        <th>Amazon Advertisement </th>
                        <th>Amazon Seller Central</th>

                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in tabledata" :key="index">
                        <!-- <td>{{ index + 1 }}.</td> -->

                        <td>
                            <div class="sellername">{{ item.seller_name }}</div>
                        </td>
                        <td>
                            <div class="column-container">
                                {{ item.region }}

                                <div v-if="item.sellers_country.length > 3"
                                    :data-title="getDisplayedCountryNames(item.sellers_country, false)"
                                    @mouseover="hovered = true" @mouseleave="hovered = false">

                                    {{ getDisplayedCountryNames(item.sellers_country, true) }}
                                </div>
                                <div v-else>
                                    {{ getDisplayedCountryNames(item.sellers_country, true) }}
                                </div>
                            </div>
                        </td>

                        <td>{{ item.seller_id }}</td>
                        <!-- <td>{{ item.marketplace_id }}</td> -->
                        <td>{{ toSentenceCase(item.seller_type) }}</td>
                        <td>
                            <button class="disconnectButton"
                                @click="authorizeRegion(item.endpoint, item.region, item.seller_id, item.seller_name)"
                                v-if="item.connection_status === 'disconnected'">Connect Now</button>
                            <button class="connectionButton" v-else
                                :disabled="item.connection_status === 'connected' || item.connection_status === 'ad_authorised'">Connected</button>
                        </td>
                        <td><button class="disconnectButton"
                                @click="authorizeRegion(item.endpoint, item.region, item.seller_id, item.seller_name)"
                                v-if="item.connection_status === 'ad_authorised'">Connect Now</button>
                            <button class="connectionButton" v-else
                                :disabled="item.connection_status === 'connected'">Connected</button>
                        </td>

                    </tr>

                </tbody>
            </table>

        </div>

    </div>
</template>
<script>

export default {
    data() {
        return {
            api_url: this.$store.state.API_URL[process.env.VUE_APP_ENV],
            app_url: this.$store.state.APP_URL[process.env.VUE_APP_ENV],
            endpoint_url: this.$store.state.ENDPOINT_URL,
            tabledata: [],
            showFullList: false,
            buttonText: 'Refresh',
            isFetching: false,
            fetchdata: '',


        }
    },
    mounted() {
        // Check if the page has already been reloaded

        if (localStorage.getItem('sp_api_connection') === 'true' || localStorage.getItem('sp_api_connection') === 'progress') {
            // Set a flag in local storage to indicate that the reload has happened
            localStorage.setItem('sp_api_connection', '');
            console.log('reloaded true', localStorage.getItem('sp_api_connection'))
            // Reload the entire page
            window.location.reload();
            // Adjust the delay as needed
        } else {
            console.log('reloaded false', localStorage.getItem('sp_api_connection'))
            if (localStorage.getItem('sp_api_connection') === 'error') {
                var err = "Seller ID doesn't match: Please make sure the seller you are choosing in this window matches with the seller you are selecting from seller central!!";
                this.$alert(
                    err,
                    "Seller selection mismatch",
                    "error"
                );
            }

            localStorage.setItem('sp_api_connection', '');

            // Page has already been reloaded, proceed with normal initialization
            this.datasync();
            this.startTime = new Date();

        }
    },

    methods: {
        //     trackPageDuration() {
        //   const endTime = new Date();
        //   const duration = (endTime - this.startTime) / 1000; // Convert milliseconds to seconds
        //   this.$mixpanel.track('Page View - Settings', {
        //     page: "Settings",
        //     duration_seconds:` User spends ${duration} seconds`
        //   });
        // },
        datasync() {
            this.$q.loading.show({
                message: "Syncing the connection details...",
            });
            const endTime = new Date();
            const duration = (endTime - this.startTime) / 1000; // Convert milliseconds to seconds
            this.$mixpanel.track_pageview({ "page": "Settings", "duration": duration });
            const payload = []

            var connectingData = this.api_url + `/amazon-ad/authorise_seller_central/${this.$top_level_orgid.label}`;

            this.$http
                .post(connectingData, payload)
                .then((response) => {
                    var tabular_data = response.data;
                    this.tabledata = tabular_data;

                    this.$q.loading.hide();


                    console.log("tabular data", response.data);
                })
                .catch((error) => {
                    console.error("Error making POST request", error);
                    this.$q.loading.hide();
                });

        },
        toSentenceCase(str) {
            if (!str) return str; // Handle null or empty string
            return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
        },
        authorizeRegion(endpoint, region, seller_id, seller_name) {
            localStorage.setItem(
                "region",
                region
            );
            localStorage.setItem(
                "seller_id",
                seller_id
            );
            console.log("endpoint::", endpoint)
            window.location.href = endpoint;
            this.$mixpanel.track('Connecting Sellers(Settings Page)', {
                Action: `The User connecting with this seller : ${seller_name}`,
                UserEmail: localStorage.getItem('email'),
                Time: new Date().toISOString(),
            })
        },

        get_country_names(country_list) {
            return country_list.join(', ');
        },
        getDisplayedCountryNames(countries, trim) {
            // console.log('countries', countries)
            if (trim) {
                // console.log(countries.slice(0, 3).join(', ') + '...')
                if (countries.length > 3) {
                    return countries.slice(0, 3).join(', ') + ' ...';
                } else {
                    return countries.slice(0, 3).join(', ')
                }


            } else {
                return countries.join(', ');
            }
        },
        addconnection() {
            let endpoint = `${this.endpoint_url}&redirect_uri=${this.app_url}/amazonadoptimization/connect/1`
            console.log('endpoint', endpoint)
            window.location.href = endpoint;
            this.$mixpanel.track('AddConnection(Settings page)', {

                Action: `The User adding connection`,
                UserEmail: localStorage.getItem('email'),
                Time: new Date().toISOString(),
            })
        },
        refresh() {
            this.buttonText = 'Refreshing';
            if (this.buttonText === 'Refreshing') {
                this.isFetching = true;
            }
            else {
                this.isFetching = false;
            }
            let fetchmoreData = this.api_url + `/amazon-ad/fetch_more/${this.$top_level_orgid.label}`;
            this.$http.post(fetchmoreData)
                .then((response) => {
                    console.log('FetchmoreData', response.data)
                    this.$mixpanel.track('Refreshing data(Settings page)', {

                        Action: `The User refreshed the data succesfully`,
                        UserEmail: localStorage.getItem('email'),
                        Time: new Date().toISOString(),
                    })

                })
                .catch((error) => {
                    console.log('FetchmoreDataError', error)
                    this.$mixpanel.track('Error in Refreshing data(Settings page)', {

                        Action: `The User encountered an issue while refreshing data`,
                        UserEmail: localStorage.getItem('email'),
                        Time: new Date().toISOString(),
                    })
                })

            let refreshData = this.api_url + `/amazon-ad/check_refresh_status/${this.$top_level_orgid.label}`;
            this.$http.post(refreshData)
                .then((response) => {
                    console.log('FetchingData', response.data);
                    const FetchingData = response.data;
                    const newData = response.data.data



                    if (FetchingData.status === 'DONE') {

                        this.tabledata = newData;
                        this.buttonText = 'Refresh';
                        this.isFetching = false;
                        this.$alert('Profile Updated', '', 'success');
                    }
                    else if (FetchingData.status === 'NC') {
                        this.buttonText = 'Refresh';
                        this.isFetching = false;
                        this.$alert('No Modification', '', 'success');
                    }
                    else if (FetchingData.status === 'FAILED') {
                        this.buttonText = 'Refresh';
                        this.isFetching = false;
                        this.$alert('Failed', '', 'error');

                    }
                    else if (FetchingData.status === 'IN-PROGRESS') {
                        this.buttonText = 'Refreshing';
                        this.isFetching = true;
                    }
                })
                .catch((error) => {
                    console.log('FetchingDataError', error);
                });

        }
    },



};
</script>
<style src=".././utilities/Components/Card/style.css">
/* @import '../assets/css/startpage.css'; */
</style>
<style scoped>
.homedashboard {
    margin-top: 1.5rem;
    margin-left: 30px;
    margin-right: 30px;
}

.table-wrapper {
    margin-top: 1.5rem;
    margin-left: 30px;
    margin-right: 30px;
    border-radius: 5px;
    background-color: white;
    border-collapse: collapse;

}

.btn-add {
    margin-top: 30px;
    margin-left: 30px;
    margin-right: 30px;
    border-radius: 5px;
    /* background-color: white; */
    display: flex;
    justify-content: end;
    gap: 10px;

}

table {
    border-collapse: collapse;
    width: 100%;
    /* Ensure the table takes the full width of its container */
}

th,
td {
    border-top: none;
    border-left: none;
    border-right: none;
    border-bottom: 1px solid #ccc;
    /* Add a bottom border */
    padding: 8px;
    /* Add some padding for better spacing */
    text-align: center;
}


table>thead {
    background-color: #E7EBF0;
}

[data-title] {
    font-size: 12px;
    position: relative;
    /* cursor: help; */
}

[data-title]:hover::before {
    content: attr(data-title);
    position: absolute;
    bottom: -46px;
    padding: 10px;
    background: #000;
    color: #fff;
    font-size: 14px;
    white-space: nowrap;
}

[data-title]:hover::after {
    content: '';
    position: absolute;
    bottom: -12px;
    left: 8px;
    border: 8px solid transparent;
    border-bottom: 8px solid #000;
}

.refresh {
    /* background: none;
    border: none;
    cursor: pointer; */
    background-color: #378cef;
    color: white;
    padding: 5px;
    border: none;
    cursor: pointer;
    height: 2.4rem;
}

.add {
    background-color: #378cef;
    color: white;
    padding: 5px;
    border: none;
    cursor: pointer;
    /* width: 120px; */
    height: 2.4rem;
}

.q-icon {
    font-size: medium;
}

.column-container {
    display: flex;
    flex-direction: column;
}

@media only screen and (max-width: 650px) {
    td>.sellername {
        font-weight: bold;
    }

    th {
        display: none;
    }

    td {
        display: grid;
        gap: 0.5rem;
        grid-template-columns: 15ch auto;
        padding: 0.5rem 1rem;
        text-align: left;
    }

    td:first-child {
        padding-top: 2rem;
    }

    td:nth-child(5n) {
        border-bottom: 1px solid #CCCCCC !important;
        /* Add your desired border-bottom style */
    }

    td:nth-child(6n) {
        border-bottom: 2px solid #000 !important;
        /* Add your desired border-bottom style */
    }

    td:last-child {
        padding-top: 2rem;
    }

    td:nth-of-type(1)::before {
        content: "Seller Name";
        display: flex;
        align-items: center;
        font-weight: bold;

    }

    td:nth-of-type(2)::before {
        content: "Region";
        display: flex;
        align-items: center;
        font-weight: bold;
    }

    td:nth-of-type(3)::before {
        content: "Seller ID";
        display: flex;
        align-items: center;
        font-weight: bold;
    }

    td:nth-of-type(4)::before {
        content: "Type";
        display: flex;
        align-items: center;
        font-weight: bold;
    }

    td:nth-of-type(5)::before {
        content: "Amazon Advertisement";
        display: flex;
        align-items: center;
        font-weight: bold;
    }

    td:nth-of-type(6)::before {
        content: "Amazon Seller Central";
        display: flex;
        align-items: center;
        font-weight: bold;
    }

}
</style>